import React from 'react';
import {Box, Center, Text, Link} from '@chakra-ui/react';

export const TrapLeagueResults = () => {
  return (
    <Box mt={6}>
      <Center>
        <Text as="h3" color="#000000" fontSize={{ base: '22px' }} fontWeight="600">Trap League Results</Text>
      </Center>
      <Box>For current Trap League results, contact <Link href="mailto:competitions@goldengunclub.us">competitions@goldengunclub.us</Link></Box>
    </Box>
  );
};
